import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.666 1.667A3.333 3.333 0 0 0 3.333 5v9.167A3.333 3.333 0 0 0 6.666 17.5h4.584a.833.833 0 0 0 0-1.667H6.666c-.92 0-1.666-.746-1.666-1.666V5c0-.92.746-1.667 1.666-1.667H10v3.334c0 .92.746 1.666 1.666 1.666H15v.834a.833.833 0 0 0 1.666 0V7.702a3.33 3.33 0 0 0-.976-2.357l-2.702-2.702a3.33 3.33 0 0 0-2.357-.976zm7.973 5a2 2 0 0 0-.127-.143L11.809 3.82a2 2 0 0 0-.143-.127v2.973zm-2.14 7.916c0-.46.374-.833.834-.833H15v-1.667a.833.833 0 0 1 1.666 0v1.667h1.667a.833.833 0 0 1 0 1.667h-1.667v1.666a.833.833 0 1 1-1.666 0v-1.666h-1.667a.833.833 0 0 1-.833-.834",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }